module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.fb435102.jpg";